export const recipientConstants = {
    // Add and editing recipient
    SAVING_RECIPIENT_REQUEST: 'SAVING_RECIPIENT_REQUEST',
    SAVING_RECIPIENT_SUCCESS: 'SAVING_RECIPIENT_SUCCESS',
    SAVING_RECIPIENT_FAILURE: 'SAVING_RECIPIENT_FAILURE',

    // Loading recipients
    LOAD_RECIPIENTS_REQUEST: 'LOAD_RECIPIENTS_REQUEST',
    LOAD_RECIPIENTS_SUCCESS: 'LOAD_RECIPIENTS_SUCCESS',
    LOAD_RECIPIENTS_FAILURE: 'LOAD_RECIPIENTS_FAILURE',

    // Delete recipients
    DELETE_RECIPIENT_REQUEST: 'DELETE_RECIPIENT_REQUEST',
    DELETE_RECIPIENT_SUCCESS: 'DELETE_RECIPIENT_SUCCESS',
    DELETE_RECIPIENT_FAILURE: 'DELETE_RECIPIENT_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/recipient.constants.js